module.exports = "/_next/static/images/BargeS-9213514084a74872a15ecae2bf036bd1.png";